export default __webpack_public_path__ + "static/media/volts.0997d060.svg";